const moveAllUnselected = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m4.269 3.559.982.851-3.13 3.614 3.06 3.535-.982.85L.4 8.025zm7.484 0 3.798 4.385-3.868 4.466-.983-.851 3.13-3.615-3.06-3.534zM10.276 5.7V10h-4.3V5.7zm-1 .999h-2.3v2.3h2.3z"/></svg>',
};

export { moveAllUnselected as default };
